var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton"},[(_vm.title || _vm.buttons)?_c('header',[(_vm.title)?_c('b-skeleton',{attrs:{"type":"input"}}):_vm._e(),_c('div',{staticClass:"skeleton-buttons"},_vm._l((_vm.buttons),function(i){return _c('b-skeleton',{key:i,attrs:{"type":"button"}})}),1)],1):_vm._e(),_c('b-skeleton-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"table-props":{
      small: _vm.small,
      striped: true,
      borderless: true,
      outlined: true,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }